import { countries } from "../../../../data/countries";
import { provinces } from "../../../../data/province";
import { states } from "../../../../data/states";

// The United States under the names people actually type. Matched against the
// whole value: the earlier test looked for "us" anywhere, so Australia and
// Russia came out as USA.
const UNITED_STATES = /^(u\.?\s?s\.?(\s?a\.?)?|united states( of america)?|america)$/i;

const COUNTRIES = [{ value: "USA", label: "United States" }, ...countries];
const REGIONS = [...states, ...provinces];

const findByCodeOrName = (value: string, options: { value: string; label: string }[]) => {
  const wanted = value.toLowerCase();
  return options.find(
    (option) => option.value.toLowerCase() === wanted || option.label.toLowerCase() === wanted
  );
};

// Codes stay as typed when nothing matches, so the row's own check can flag them.
export const normalizeCountry = (value: string | null | undefined): string => {
  const text = (value ?? "").trim();
  if (!text) return "";
  if (UNITED_STATES.test(text)) return "USA";

  return findByCodeOrName(text, COUNTRIES)?.value ?? text;
};

export const normalizeRegion = (value: string | null | undefined): string => {
  const text = (value ?? "").trim();
  if (!text) return "";

  return findByCodeOrName(text, REGIONS)?.value ?? text;
};
